import { render, staticRenderFns } from "./SignupStudent.vue?vue&type=template&id=7023ed86"
import script from "../../services/student/signup-student.js?vue&type=script&lang=js&external"
export * from "../../services/student/signup-student.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/student/signup-student.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports